// extracted by mini-css-extract-plugin
export default {"videoContainer":"CircularVideo_videoContainer__+WkZv","circularVideo":"CircularVideo_circularVideo__-6ke3"};